module.exports = __webpack_public_path__ + "img/migrantes2.260b12c9.png";